import * as React from 'react';
import AuthContext from '../AuthContext.js';
import { doSignOut } from '../utils/reducers.js';
import { logout } from '../../Services/AuthApiService.js';
import { useAuthHeader } from '../AuthService.js';

/**
  *@public
  *@function
  *@name useSignOut
  *@description Sign out Hook
  */
function useSignOut() {
    /**
     *A constant c.
     *@kind constant
     */
    var context = React.useContext(AuthContext);
    if (context === null) {
        throw new Error("Sign out error");
    }
    const authHeader = useAuthHeader();
    return function () {
        try {
            if (context) {
                logout(authHeader());
                context.dispatch(doSignOut());
                return true;
            }
            else {
                return false;
            }
        }
        catch (e) {
            return false;
        }
    };
}

export { useSignOut as default };
